import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-modal',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{title}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="alert alert-warning">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                {{message}}
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cerrar</button>
        </div>
    `,
    styles: [`
        :host ::ng-deep .modal-content {
            max-width: 400px;
            margin: 0 auto;
        }
        .modal-body {
            padding: 1rem;
        }
        .alert {
            margin-bottom: 0;
        }
    `],
    standalone: false
})
export class ConfirmModalComponent {
    @Input() title: string = 'Atención';
    @Input() message: string;

    constructor(public activeModal: NgbActiveModal) {}
}
